// extracted by mini-css-extract-plugin
module.exports = {"container":"PageBody_container___YI0h","inner":"PageBody_inner__bywX5"};